<template>
  <div>
    <div class="jumbotron">
      <h1>Créer une recherche</h1>
      <h4>La recherche est le principe de base de lookeoo.</h4>
      <h5>Créez-là, invitez vos co-chercheurs et définissez votre première requête associée.</h5>
    </div>

    <div class="container">
      <form @submit.prevent="saveSearch">
        <div
          class="alert alert-danger"
          role="alert"
          v-bind:class="{ hide: status.errorMessage == null }"
        >{{status.errorMessage}}</div>

        <div class="control-group">
          <div class="form-group floating-label-form-group controls mb-0 pb-2">
            <label>Donnez un nom à votre recherche</label>
            <input
              type="text"
              class="form-control"
              v-model="form.name"
              aria-describedby="searchNameHelp"
              placeholder="Donnez un nom à votre recherche"
            />
            <small
              id="searchNameHelp"
              class="form-text text-muted"
            >Décrivez le nom de votre recherche</small>
          </div>
        </div>

        <!-- 
        <div class="control-group">
          <div class="form-group floating-label-form-group controls mb-0 pb-2">
            <label>Description</label>
            <textarea
              rows="3"
              type="text"
              class="form-control"
              v-model="form.description"
              aria-describedby="descriptionHelp"
              placeholder="Description"
            />
            <small
              id="descriptionHelp"
              class="form-text text-muted"
            >Décrivez le pourquoi du comment de votre recherche, cela sera notamment utilisé lors des invitations auprès de vos co-chercheurs</small>
          </div>
        </div> 
        -->

        <br />
        <div style="margin-top: 20px;">
          <h2>Définissez vos critères de recherche</h2>
          <small>Ces premiers critères vont créer votre première requête, vous pourrez en ajouter d'autres ensuite.</small>
          <br />
          <br />

          <div class="form-group floating-label-form-group controls mb-0 pb-2" style="margin-top: 40px;">
            <label>Nom de la requête</label>
            <input
              type="text"
              class="form-control"
              v-model="queryName"
              aria-describedby="searchNameHelp"
              placeholder="Nom de la requête"
              disabled="disabled"
            />
            <small
              id="searchNameHelp"
              class="form-text text-muted"
            >Description de votre requête (par exemple: Paris 15ème, 3 pièces entre 40 et 60m² pour maximum 550 000€)</small>
          </div>

          <div style="margin-top: 40px;margin-bottom: 40px;">
            <div class="row">
              <div class="form-group col-md-3 text-left">
                <label>Nombre minimum de pièces</label>

                <select class="custom-select" v-model="multi.rooms">
                  <option value="1">1+</option>
                  <option value="2">2+</option>
                  <option value="3">3+</option>
                  <option value="4">4+</option>
                  <option value="5">5+</option>
                </select>
              </div>

              <div class="form-group col-md-3 text-left">
                <label>Surface</label>
                <div class="row">
                  <div class="col-6">
                    <input
                      type="number"
                      class="form-control"
                      v-model="multi.surface.minimum"
                      aria-describedby="surfaceMinimumHelp"
                      placeholder="Min Surface (m²)"
                    />
                    <small
                      id="surfaceMinimumHelp"
                      class="form-text text-muted text-center"
                    >Surface Minimum</small>
                  </div>
                  <div class="col-6">
                    <input
                      type="number"
                      class="form-control"
                      v-model="multi.surface.maximum"
                      aria-describedby="surfaceMaximumHelp"
                      placeholder="Max Surface (m²)"
                    />
                    <small
                      id="surfaceMaximumHelp"
                      class="form-text text-muted text-center"
                    >Surface Maximum (0 si pas de limite)</small>
                  </div>
                </div>
              </div>

              <div class="form-group col-md-3 text-left">
                <label>Prix</label>
                <div class="row">
                  <div class="col-6">
                    <input
                      type="number"
                      class="form-control"
                      v-model="multi.price.minimum"
                      aria-describedby="priceMinimumHelp"
                      placeholder="Min Price (€)"
                    />
                    <small
                      id="priceMinimumHelp"
                      class="form-text text-muted text-center"
                    >Prix Minimum</small>
                  </div>
                  <div class="col-6">
                    <input
                      type="number"
                      class="form-control"
                      v-model="multi.price.maximum"
                      aria-describedby="priceMaximumHelp"
                      placeholder="Max Price (€)"
                    />
                    <small
                      id="priceMaximumHelp"
                      class="form-text text-muted text-center"
                    >Prix Maximum (0 si pas de limite)</small>
                  </div>
                </div>
              </div>

              <div class="form-group col-md-3">
                <label>Villes</label>
                <div class="row">
                  <vue-tags-input
                    v-model="cityComplete"
                    :autocomplete-items="filteredItems"
                    :add-only-from-autocomplete="true"
                    :tags="multi.cities"
                    @tags-changed="newTags => multi.cities = newTags"
                  />
                </div>

                <div class="row">
                  <label>Location ou achat ?</label>

                  <select class="custom-select" v-model="multi.sellingType">
                    <option value="Selling">Achat (ancien)</option>
                    <option value="SellingNew">Achat (neuf)</option>
                    <option value="Renting">Location</option>
                    <option value="Lifetime">Viager</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </div>

        <br />
        <div class="list-users">
          <h2>Définissez vos co-cherheurs</h2>
          <small>Invitez ici vos co-chercheurs. Ils recevront alors une invitation pour participer à cette recherche.</small>
          <br />
          <br />

          <div class="row item-user" v-for="(user, index) in form.searchUsers">
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="user.fullName"
                placeholder="Nom ou pseudo de votre co-chercheur"
              />
            </div>
            <div class="col-md-5">
              <input
                type="email"
                class="form-control"
                v-model="user.email"
                placeholder="Email de votre co-chercheur"
              />
            </div>
            <div class="col-md-1">
              <button
                type="button"
                @click="deleteUser(index)"
                class="btn btn-outline-light btn-social mx-1 btn-close"
              >X</button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <button
                type="button"
                class="btn btn-secondary btn-l btn-addco"
                @click="addEmptyUser()"
              >
                <i class="fas fa-user mr-2"></i>Ajouter un autre co-chercheur
              </button>
            </div>
          </div>
        </div>

        <br />
        <div>
          <div class="row">
            <div class="col-md-12">
              <button
                type="submit"
                class="btn btn-primary btn-xl btn-submit"
                v-show="!status.loading"
              >
                <i class="fas fa-rocket mr-2"></i>Créer la recherche
              </button>

              <div class="spinner-border text-primary" role="status" v-show="status.loading">
                <span class="sr-only">Mise à jour en cours...</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueTagsInput from "@johmun/vue-tags-input";
import jsonCities from "@/assets/cities.json";

export default {
  components: {
    VueTagsInput
  },
  name: "SearchAdd",
  data() {
    return {
      form: { searchUsers: [{ fullName: "", email: "" }] },
      formQuery: {
        externalSourceId: 0,
        queryName: "",
        jsonQuery: "",
        sourceId: 0
      },
      cityComplete: "",
      multi: {
        sellingType: "",
        rooms: 0,
        surface: { minimum: 0, maximum: 0 },
        price: { minimum: 0, maximum: 0 },
        cities: []
      },
      availableCities: jsonCities,
      // availableCities: [
      //   { text: "75 - Paris", value: "75000" },
      //   { text: "75001 - Paris", value: "75001" },
      //   { text: "75002 - Paris", value: "75002" },
      //   { text: "75003 - Paris", value: "75003" },
      //   { text: "75004 - Paris", value: "75004" },
      //   { text: "75005 - Paris", value: "75005" },
      //   { text: "75006 - Paris", value: "75006" },
      //   { text: "75007 - Paris", value: "75007" },
      //   { text: "75008 - Paris", value: "75008" },
      //   { text: "75009 - Paris", value: "75009" },
      //   { text: "75010 - Paris", value: "75010" },
      //   { text: "75011 - Paris", value: "75011" },
      //   { text: "75012 - Paris", value: "75012" },
      //   { text: "75013 - Paris", value: "75013" },
      //   { text: "75014 - Paris", value: "75014" },
      //   { text: "75015 - Paris", value: "75015" },
      //   { text: "75016 - Paris", value: "75016" },
      //   { text: "75017 - Paris", value: "75017" },
      //   { text: "75018 - Paris", value: "75018" },
      //   { text: "75019 - Paris", value: "75019" },
      //   { text: "75020 - Paris", value: "75020" },
      //   { text: "Evry", value: "91000" },
      //   { text: "Soisy-sur-seine / Etiolles", value: "91450" }
      // ],
      // searchItems: [],
      status: { loading: false, errorMessage: null }
    };
  },
  computed: {
    queryName() {
      var searchName =
        this.multi.cities.map(city => city.value).join(",") + " - ";
      searchName += this.multi.rooms + "+ pièces, ";
      if (this.multi.surface.minimum != 0 || this.multi.surface.maximum != 0) {
        if (this.multi.surface.maximum == 0)
          searchName += "minimum " + this.multi.surface.minimum + "m², ";
        else if (this.multi.surface.minimum == 0)
          searchName += "maximum " + this.multi.surface.maximum + "m², ";
        else
          searchName +=
            this.multi.surface.minimum +
            " à " +
            this.multi.surface.maximum +
            "m², ";
      }
      if (this.multi.price.minimum != 0 || this.multi.price.maximum != 0) {
        if (this.multi.price.maximum == 0)
          searchName += "minimum " + this.multi.price.minimum + "€";
        else if (this.multi.price.minimum == 0)
          searchName += "maximum " + this.multi.price.maximum + "€";
        else
          searchName +=
            this.multi.price.minimum + "€ à " + this.multi.price.maximum + "€";
      }

      this.formQuery.queryName = searchName;
      return searchName;
    },
    filteredItems() {
      return this.availableCities.filter(i => {
        return (
          i.text.toLowerCase().indexOf(this.cityComplete.toLowerCase()) !== -1
        );
      });
    }
  },
  methods: {
    deleteUser: function(index) {
      var vm = this;
      vm.form.searchUsers.splice(index, 1);
    },
    addEmptyUser: function() {
      var vm = this;
      vm.form.searchUsers.push({ fullName: "", email: "" });
    },
    saveSearch: function() {
      var vm = this;

      var queryModel = {};
      queryModel.queryName = vm.formQuery.queryName;

      queryModel.jsonQuery = JSON.stringify(vm.multi);

      vm.status.loading = true;

      vm.form.query = queryModel;

      axios
        .post(process.env.BACKEND_URL + "/api/searches/full", vm.form)
        .then(response => {
          vm.status.loading = false;

          if (response.status == 200) {
            vm.$router.push({
              name: "SearchDetails",
              params: { id: response.data.searchId }
            });
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == 500)
              vm.status.errorMessage =
                "Erreur serveur : <br /><i>" +
                JSON.stringify(error.response.data) +
                "</i>";
          } else
            vm.status.errorMessage =
              "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.loading = false;
        });

      return false;
    }
  }
};
</script>

<style scope>
.btn-close {
  color: #ced4da;
  border-color: #ced4da;
  width: 2.25rem;
  height: 2.25rem;
  font-size: 1;
}

.btn-addco {
  margin-top: 10px;
}

.btn-submit {
  margin-top: 20px;
}

.vue-tags-input {
  width: 100%;
  max-width: 100%;
}

.ti-input {
  border: 0.125rem solid #ced4da;
  border-radius: 0.5rem;
  width: 100%;
}

.ti-tag {
  background-color: #2c3e50 !important;
}

.item-user {
  margin-bottom: 10px;
}

.search-items {
}

.search-items .search-item {
  margin-bottom: 10px;
}

.search-items .search-item .search-item-picture {
  max-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchAdd.vue